module.exports = __webpack_public_path__ + "static/img/6.502213e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/zh/6.png
// module id = rhiu
// module chunks = 0